var map = {
	"./achievements/router": "KC10",
	"./members/router": "1tpf",
	"./news/router": "bY0o",
	"./registration/router": "QG7z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yQue";


//////////////////
// WEBPACK FOOTER
// ./src/pmgc ^\.\/.*\/router$
// module id = yQue
// module chunks = 1